module.exports = __webpack_public_path__ + "img/2024_03.99d4ea26.jpg";